import type { FC } from 'react';
import { Avatar, Space, Typography } from 'antd';
import { WORK_ORDER_UI } from '~/app/components/maintenance/work-orders/work-order-ui-colors';

export interface TechnicianNameBadgeProps {
  name: string;
  size?: number;
}

/** Rounded navy initial avatar + name — matches Kanban card assignment row. */
export const TechnicianNameBadge: FC<TechnicianNameBadgeProps> = ({
  name,
  size = 20,
}) => {
  const trimmed = name.trim();
  if (!trimmed) return null;

  return (
    <Space size={6} align="center">
      <Avatar
        size={size}
        style={{
          background: WORK_ORDER_UI.sidebarNavy,
          fontSize: Math.max(10, Math.round(size * 0.55)),
          flexShrink: 0,
        }}
      >
        {trimmed.slice(0, 1).toUpperCase()}
      </Avatar>
      <Typography.Text
        ellipsis
        style={{ fontSize: 12, maxWidth: 160, lineHeight: `${size}px` }}
      >
        {trimmed}
      </Typography.Text>
    </Space>
  );
};
